export const GET_LOCALITIES_REQUEST = 'LAB.CERTIFICATES_MODAL.GET_LOCALITIES_REQUEST';
export const GET_LOCALITIES_SUCCESS = 'LAB.CERTIFICATES_MODAL.GET_LOCALITIES_SUCCESS';
export const GET_LOCALITIES_ERROR = 'LAB.CERTIFICATES_MODAL.GET_LOCALITIES_ERROR';

export const ACCEPT_SUGGESTION_REQUEST = 'LAB.CERTIFICATES_MODAL.ACCEPT_SUGGESTION_REQUEST';
export const ACCEPT_SUGGESTION_SUCCESS = 'LAB.CERTIFICATES_MODAL.ACCEPT_SUGGESTION_SUCCESS';
export const ACCEPT_SUGGESTION_ERROR = 'LAB.CERTIFICATES_MODAL.ACCEPT_SUGGESTION_ERROR';

export const SET_CERTIFICATES_SECTION_REQUEST = 'LAB.CERTIFICATES_MODAL.SET_CERTIFICATES_SECTION_REQUEST';
export const SET_CERTIFICATES_SECTION_SUCCESS = 'LAB.CERTIFICATES_MODAL.SET_CERTIFICATES_SECTION_SUCCESS';
export const SET_CERTIFICATES_SECTION_ERROR = 'LAB.CERTIFICATES_MODAL.SET_CERTIFICATES_SECTION_ERROR';

export const CLOSE_SUGGESTION = 'LAB.CERTIFICATES_MODAL.CLOSE_SUGGESTION';
export const CANCEL_SUGGESTION = 'LAB.CERTIFICATES_MODAL.CANCEL_SUGGESTION';
